import { Component } from 'react'
import { connect } from 'react-redux'
import { parseUrlParams } from '../../cdl-react-components/utilities'
import { WEBHOST_URL } from '../../cdl-react-components/utilities/constants'
import { logEvent } from '../../../utilities'


class Pdf extends Component {
    state = {}

    constructor(props) {
        super(props)

        const { id } = parseUrlParams()
        logEvent({ 'Article_PDF_Viewed': id })
    }

    render() {
        const { url, id } = parseUrlParams()
        
        if (!url || (url.indexOf('private') >= 0 && !this.props.authenticated)) {
            window.location.href = this.props.location + "/article/" + id
        }

        return (
            <div className="pdf">
                <iframe title="PDF Viewer" src={ '/static/lib/pdfjs/web/viewer.html?file=' + WEBHOST_URL + url + '&page=' + (this.state.page || 1) + '&article=' + id }
                        runat="server" />
            </div>
        )
    }

    componentDidMount() {
        const { url, page } = parseUrlParams()
        this.setState({ url, page })
    }
}

const mapStateToProps = ({data}) => ({ authenticated: data.authenticated })

export default connect(mapStateToProps)(Pdf)